import { render, staticRenderFns } from "./cenPlain.vue?vue&type=template&id=e8d7895e&scoped=true&"
import script from "./cenPlain.vue?vue&type=script&lang=js&"
export * from "./cenPlain.vue?vue&type=script&lang=js&"
import style0 from "./cenPlain.vue?vue&type=style&index=0&id=e8d7895e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8d7895e",
  null
  
)

export default component.exports